import React from 'react';
import AffiliateLink from './AffiliateLink';

const ProductBundle = ({ className = '' }) => {
  return (
    <AffiliateLink className={`block ${className}`}>
      <div className="relative bg-gradient-to-br from-[#2a2a2a] to-[#1a1a1a] rounded-lg p-6 shadow-2xl max-w-md mx-auto transform hover:scale-105 transition-transform duration-300">
        {/* Main product book mockup */}
        <div className="flex items-center justify-center gap-4">
          {/* Main book */}
          <div className="relative">
            <div className="w-40 h-52 bg-gradient-to-br from-[#cc0000] to-[#990000] rounded-sm shadow-xl transform -rotate-6">
              <div className="absolute inset-2 border border-white/20 rounded-sm flex flex-col items-center justify-center p-2">
                <div className="text-yellow-400 text-2xl mb-1">⚡</div>
                <div className="text-white text-xs font-bold text-center leading-tight">
                  ENERGY<br/>REVOLUTION<br/>SYSTEM
                </div>
                <div className="text-yellow-400 text-[8px] mt-2">COMPLETE BLUEPRINTS</div>
              </div>
            </div>
          </div>
          
          {/* Bonus materials */}
          <div className="space-y-2">
            <div className="w-24 h-16 bg-gradient-to-br from-[#2196F3] to-[#1565C0] rounded-sm shadow-lg transform rotate-3">
              <div className="flex items-center justify-center h-full text-white text-[8px] font-bold text-center px-1">
                BONUS<br/>MATERIALS
              </div>
            </div>
            <div className="w-24 h-16 bg-gradient-to-br from-[#4CAF50] to-[#2E7D32] rounded-sm shadow-lg transform -rotate-2">
              <div className="flex items-center justify-center h-full text-white text-[8px] font-bold text-center px-1">
                PARTS<br/>CHECKLIST
              </div>
            </div>
          </div>
        </div>
        
        {/* Label */}
        <div className="text-center mt-4">
          <p className="text-gray-400 text-sm italic">Digital Product</p>
        </div>
      </div>
    </AffiliateLink>
  );
};

export default ProductBundle;